const titlePageToolNode = (data) => {
  return {
    type: 'titlePage',
    id: 'title-node',
    content: data.toolData,
  };
};

export { titlePageToolNode };
